module.exports = __webpack_public_path__ + "img/echoes-traveler.14d1eae0.png";